import { LegalShell } from "./LegalShell";

export default function Accessibility() {
  return (
    <LegalShell
      title="Accessibility"
      subtitle="Every student deserves to feel like the only one in the room. Here's how we build for that on the web too."
      path="/accessibility"
      updated="February 12, 2026"
      sections={[
        {
          id: "commitment",
          heading: "Our commitment",
          body: (
            <>
              <p>Heather's Boutique is committed to making our website usable by every visitor, including
              those with visual, motor, cognitive, or hearing differences. We aim to conform to the Web
              Content Accessibility Guidelines (WCAG) 2.1 Level AA.</p>
            </>
          ),
        },
        {
          id: "what-we-do",
          heading: "What we do today",
          body: (
            <>
              <ul className="list-disc pl-5 space-y-1.5">
                <li>All interactive controls are keyboard-navigable</li>
                <li>Color contrast meets or exceeds 4.5:1 for body text</li>
                <li>Product images have descriptive alt text</li>
                <li>Forms include visible labels and error announcements</li>
                <li>Screen-reader landmarks (header, main, nav, footer) are present on every page</li>
                <li>Animations respect the "prefers-reduced-motion" system setting</li>
              </ul>
            </>
          ),
        },
        {
          id: "help",
          heading: "Need help ordering?",
          body: (
            <>
              <p>If any part of the site is a barrier for you, we'll walk you through by phone or email and
              place the order on your behalf, no charge — call <a className="text-rosemetal" href="tel:+18884506525">(888) 450-6525</a>
              or email <a className="text-rosemetal" href="mailto:info@heathersboutique.com">info@heathersboutique.com</a>.</p>
            </>
          ),
        },
        {
          id: "feedback",
          heading: "Feedback",
          body: (
            <p>If you find an accessibility issue, please tell us at
            <a className="text-rosemetal" href="mailto:support@heathersboutique.com"> support@heathersboutique.com</a>.
            We aim to resolve reported issues within 5 business days.</p>
          ),
        },
      ]}
    />
  );
}
